const part = [
    {
        path: 'category-list',
        name: 'category-list',
        meta: {
            icon: 'md-cube',
            title: '类别管理',
            notCache: true,
            access: ['S', 'A'],
            items: [
            ]
        },
        component: () => import('@/view/product-management/category-management/category-list')
    }
];

export default part;
